<template>
    <div>
        <p>
            <strong>Código: </strong>
            <span>{{activoObject.codigo}}</span>
            <br />
            <strong>Marca: </strong>
            <span>{{ activoObject.marca ? activoObject.marca : "-" }}</span>
            <br />
            <strong>Modelo: </strong>
            <span>{{ activoObject.modelo ? activoObject.modelo : "-" }}</span>
            <br />
            <strong>Serie: </strong>
            <span>{{ activoObject.serie ? activoObject.serie : "-" }}</span>
            <hr/>
        </p>
        
        <p>
            <strong>Campus: </strong>
            <span>{{ activoObject.campus ? activoObject.campus.nombre : "-" }}</span>
            <br />
            <strong>Departamento: </strong>
            <span>{{ activoObject.departamento ? activoObject.departamento.nombre : "-" }}</span>
            <br />
            <strong>Sección: </strong>
            <span>{{ activoObject.seccion ? activoObject.seccion.nombre : "-" }}</span>
            <br />
            <strong>Edificio: </strong>
            <span>{{ activoObject.edificio ? activoObject.edificio.nombre : "-" }}</span>
            <br />
            <strong>Área: </strong>
            <span>{{ activoObject.area ? activoObject.area.nombre : "-" }}</span>
            <hr />
        </p>

        <p>
            <strong>Descripción: </strong>
            <span>{{ activoObject.descripcion ? activoObject.descripcion : "-" }}</span>
        <hr />
        </p>

        <p>
            <strong>Costo: </strong>
            <span>{{ activoObject.costo ? activoObject.costo : "-" }}</span>
            <br />
            <strong>Fecha ingreso: </strong>
            <span>{{ activoObject.fecha_ingreso ? activoObject.fecha_ingreso : "-" }}</span>
            <br />
            <strong>Fecha baja: </strong>
            <span>{{ activoObject.fecha_baja ? activoObject.fecha_baja : "-" }}</span>
        <hr />
        </p>

        <p>
            <strong>Grupo: </strong>
            <span>{{ activoObject.grupo ? activoObject.grupo.nombre : "-" }}</span>
            <br />
            <strong>Tipo: </strong>
            <span>{{  activoObject.tipo ? activoObject.tipo.nombre : "-" }}</span>
            <br />
            <strong>Estado: </strong>
            <span>{{  activoObject.estado ? activoObject.estadoa.nombre : "-"}}</span>
            <br />
            <strong>Categoría: </strong>
            <span>{{  activoObject.categoria ? activoObject.categoria.nombre : "-"}}</span>
        <hr />
        </p>

        <p>
            <strong>Responsables: </strong>
            <template v-if="activoObject.responsables.length">
                <li :key="empleado.id" v-for="empleado in activoObject.responsables">
                    {{
                    empleado.nombre +
                    " " +
                    empleado.apellido_paterno +
                    " " +
                    empleado.apellido_materno
                    }}
                </li>
            </template>
        </p>
    </div>
</template>

<script>
export default {
    name: "PrintActivoTemplate",
    props: {
        activoObject: { type: Object, default: null }
    }
}
</script>

<style scoped></style>
